import { logError } from "@/lib/logError";

// sessionStorage wrapper for non-sensitive UI flags only (pop-up / cookie banner dismissal).
// Never store credentials here; admin auth uses an httpOnly cookie.
export const sessionGet = (key) => {
  try {
    return window.sessionStorage.getItem(key);
  } catch (err) {
    logError("sessionStore.get", err);
    return null;
  }
};

export const sessionSet = (key, value) => {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (err) {
    logError("sessionStore.set", err);
  }
};

export const sessionRemove = (key) => {
  try {
    window.sessionStorage.removeItem(key);
  } catch (err) {
    logError("sessionStore.remove", err);
  }
};

// Removes values persisted by older versions in localStorage.
export const purgeLegacyLocal = (...keys) => {
  try {
    keys.forEach((k) => window.localStorage.removeItem(k));
  } catch (err) {
    logError("sessionStore.purgeLegacyLocal", err);
  }
};
